import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop, map, isEmpty } from 'lodash';
import { Button, Select, FileInput } from '../../components/base';
import { normalizeAmount, commaFormatted } from '../../utils/transformer.util';
import ReactExport from 'react-export-excel';
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class ImportSiswaUnit extends PureComponent {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    // this.getYearsOfEducationsOptions = this.getYearsOfEducationsOptions.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this.onUpload = this.onUpload.bind(this);
    this.onRemoveFile = this.onRemoveFile.bind(this);
    this._initializeData = this._initializeData.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onPosting = this.onPosting.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this._onSearchContent = this._onSearchContent.bind(this);

    const { user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id, va_code } = school_unit;

    this.state = {
      page: 1,
      selected: {},
      content: initialContent,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          periods_id: '',
          organizations_id,
          units_id: school_unit.id,
          levels_id,
          va_code,
          levels: [],
          classrooms_id: '',
        },
        error: {
          classrooms: '',
          levels: '',
        },
      },
      param: {},
      filtered: false,
    };
  }

  componentDidMount() {
      const { user } = this.props;
      const { school_unit, organizations_id, user_group } = user;
      const { content, filters, form } = this.state;
      let savedFilters = JSON.parse(window.localStorage.getItem('ImportSiswaFilters')) || filters;
      let savedForm = JSON.parse(window.localStorage.getItem('ImportSiswaForm')) || '';
      if (savedForm != '' && user.id != savedForm.value.user_id) {
        savedForm = '';
        savedFilters = filters;
      }
      console.log(savedFilters);
      console.log(savedForm);
      if (isEmpty(content.list)) {
      }
      this._initializeData(savedFilters);
      if (savedForm != '') {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              levels_id: savedForm.value.levels_id,
              units_id: savedForm.value.units_id,
              update: true,
            },
          },
          filters: {
            ...prevState.filters,
            units_id: savedForm.value.units_id,
          },
        }));
  
        if (user_group.name === 'pusat') {
          this._getPeriodsOptions({ units_id: savedForm.value.units_id.value });
          this._getParamOptionsAcademics('classrooms', {
            levels_id: savedForm.value.levels_id,
            organizations_id,
            units_id: savedForm.value.units_id.value,
          });
        } else {
          this._getParamOptionsAcademics('classrooms', {
            levels_id: savedForm.value.levels_id,
            organizations_id,
            // units_id: savedForm.value.units_id.value
          });
        }
      }
    }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { content } = this.state;
    const { school_unit, user_group } = user;
    const paramTypes = ['classrooms', 'levels'];
      paramTypes.forEach((type) => {
        this._getParamOptionsAcademics(type);
      });
    // await this.getYearsOfEducationsOptions({ units_id: school_unit.id });
    await this._getPeriodsOptions({ units_id: school_unit.id });
     if (user_group.name == 'pusat') {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          classrooms_id: savedFilters.classrooms_id,
          jenis: savedFilters.jenis,
          payments_id: savedFilters.payments_id,
          period: savedFilters.period,
        },
      }), () => {
        // commonActions.setLoading({ show: true });
        this._onSearchContent();
        this._onSearchContentTemp();
      });
    } else {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          classrooms_id: savedFilters.classrooms_id,
          jenis: savedFilters.jenis,
          payments_id: savedFilters.payments_id,
        },
      }), () => {
        // commonActions.setLoading({ show: true });
        this._onSearchContent();
        this._onSearchContentTemp();
      });
    }
  }

  onSubmit(e) {
    e.preventDefault();
    const { form } = this.state;
    const { handleUploadExcelStudentsUnit, history } = this.props;

    const res = handleUploadExcelStudentsUnit(form.value);
    if (res) {
      console.log(res);
      window.scrollTo(0, 0);
      this.setState({
        page: 1,
      });
      this.onRemoveFile();
      // history.go(0);


    }
  }

    async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const { value } = form;
    const { subject_id, classrooms_id, period } = value;
    const { units_id } = filters;
    this.setState({
      content: initialContent,
    },
    async () => {
      try {
        const {
          handleListStudentUploadUnit,
          user,
        } = this.props;
        const {
          school_unit, workingUnit, id, user_group, organizations_id,
        } = user;
        const { levels_id } = school_unit;
        const units = user_group.name == 'pusat' || user_group.name == 'perwakilan' ? units_id.value : school_unit.id;
        console.log(filters)

        const result = await handleListStudentUploadUnit({
          ...params,
          organizations_id,
          units_id: units,
          filters,
        });

        // }
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listsiswa: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listsiswa: [],
            },
          },
        }));
      }
      // }
    });
  }

     async _onSearchContentTemp(params = {}) {
    const { filters, form } = this.state;
    const { value } = form;
    const { subject_id, classrooms_id, period } = value;
    const { units_id } = filters;
    this.setState({
      content: initialContent,
    },
    async () => {
      try {
        const {
          handleListStudentTempUpload,
          user,
        } = this.props;
        const {
          school_unit, workingUnit, id, user_group, organizations_id,
        } = user;
        const { levels_id } = school_unit;
        const units = user_group.name == 'pusat' || user_group.name == 'perwakilan' ? units_id.value : school_unit.id;
        console.log(filters)

        const result = await handleListStudentTempUpload({
          ...params,
          organizations_id,
          units_id: units,
          filters,
        });

        // }
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listTemp: result,
            },
          },
        }));
      } catch (err) {
        // if (this.isMount) {
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              listTemp: [],
            },
          },
        }));
      }
      // }
    });
  }


  // async getYearsOfEducationsOptions(filters = {}) {
  //   const { getYearsOfEducationsOptions } = this.props;
  //   const res = await getYearsOfEducationsOptions(filters);

  //   map(res, (data, idx) => {
  //     const date = new Date();
  //     const start_date = new Date(data.attributes.start_date);
  //     if (date > start_date) {
  //       // tahun ajaran sekarang
  //       this.setState(prevState => ({
  //         ...prevState,
  //         filters: {
  //           ...prevState.filters,
  //           period: data.value,
  //         },
  //         form: {
  //           ...prevState.form,
  //           value: {
  //             ...prevState.form.value,
  //             periods_id: data.value,
  //           },
  //         },
  //       }));
  //     }
  //   });

  //   this.setState(prevState => ({
  //     ...prevState,
  //     param: {
  //       ...prevState.param,
  //       periods: res,
  //     },
  //   }));
  // }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions, user } = this.props;
    const { organizations_id } = user;
    filters.organizations_id = organizations_id;
    const res = await getPeriodsOptions(filters);

    map(res, (data, idx) => {
      const date = new Date();
      const start_date = new Date(data.attributes.start_date);
      if (date > start_date) {
        // tahun ajaran sekarang
        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              periods_id: data.value,
            },
          },
          filters: {
            ...prevState.filters,
            period: data.value
          }
        }));
      }
    });

       this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        periods: res,
      },
    }));
  }

  _onFormChange(event) {
    const {
      name, value, dataset, checked, type,
    } = event.target;
    const {
      inputType = 'text',
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    this.setState((prevState) => {
      let newList = [];
      let newListError = [];
      let formattedValue = value;

      if (inputType === 'number') {
        formattedValue = normalizeAmount(value);
      }
      if (inputArray) {
        if (type === 'checkbox') {
          formattedValue = checked;
        }
        newList = prevState.form.value[fieldName];
        newListError = prevState.form.error[fieldName];
        newList[arrayPosition][name] = formattedValue;
        if (name === 'code_of_account') {
          newList[arrayPosition].isCredit = value.type;
        }
        if (!isEmpty(newListError[arrayPosition])) {
          newListError[arrayPosition][name] = '';
        }
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            ...(inputArray
              ? { [fieldName]: newList }
              : { [name]: formattedValue }),
          },
          error: {
            ...prevState.form.error,
            ...(inputArray ? { [fieldName]: newListError } : { [name]: '' }),
          },
        },
      };
    });
  }

    async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { form } = this.state;
    const { units_id } = form.value;

    if (user_group.name !== 'pusat') {
      if (type === 'classrooms' || type === 'classrooms') {
        filters.organizations_id = organizations_id;
        { units_id ? filters.units_id = units_id : filters.units_id = school_unit.id; }

        // filters.units_id = 121;
      } else {
        delete filters.organizations_id;
      }
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState(prevState => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id, school_unit } = user;
    const formCopy = { ...this.state.form };

    // Hapus listsiswa dari form.value jika ada
    if (formCopy.value && formCopy.value.listsiswa) {
      const { listsiswa, ...filteredValue } = formCopy.value;
      formCopy.value = filteredValue;
    }

    this.setState(prevState => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        [name]: value,
      },
    }),
    () => {
      window.localStorage.setItem('changeDataFilters', JSON.stringify(this.state.filters));
      window.localStorage.setItem('changeDataForm', JSON.stringify(formCopy));

      if (name == 'period') {
        this._studentCount({ filters: { period: value } });
      }
      if (name === 'units_id') {
        const param = this.state.param.units;
        const levels_units = param.find(i => i.value == value.value) ? param.find(i => i.value == value.value).attributes.levels_id : '';

        this.setState(prevState => ({
          ...prevState,
          form: {
            ...prevState.form,
            value: {
              ...prevState.form.value,
              classrooms_id: '',
              levels_id: levels_units,
              units_id: value,

            },
          },
        }));
        this._getParamOptionsAcademics('classrooms', {
          levels_id: levels_units, organizations_id, units_id: value.value,
        });
        this._getPeriodsOptions({ units_id: value.value });
        this._studentCount({ units_id: value.value });
      }

      this._onSearchContent();
    });
  }

    async onPosting(data) {
    const { handlePostingUpload, history } = this.props;
    const res = await handlePostingUpload(data);
    if(res){
    history.push('/dashboard/pengaturan/import-siswa-unit');
   
    // history.go(0);
    }
  }

  async onUpload(event) {
    const {
      name, value, dataset, files,
    } = event.target;
    const { inputType = 'text' } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      if (inputType === 'number') {
        formattedValue = commaFormatted(value);
      }
      if (inputType === 'file') {
        formattedValue = files[0];
      }

      return {
        form: {
          value: {
            ...prevState.form.value,
            [name]: formattedValue,
          },
          error: {
            ...prevState.form.error,
            [name]: '',
          },
        },
      };
    });
  }

  onRemoveFile(event) {
    this.setState(prevState => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          file: '',
        },
      },
    }));
  }

  

 renderExcel(listsiswa) {
  const handleExport = async () => {
    const excelForm = listsiswa.map((list) => {
      const date = list.datebirth ? list.datebirth : "";
      const [year, month, day] = date ? date.split("-") : ["", "", ""];
      const formattedDate = `${day}-${month}-${year}`;
      return {
        nopin : list.nopin || "",
        nis : list.nis || "",
        nisn : list.nisn || "",
        no_va : list.no_va || "",
        students_name : list.students_name || "",
        last_name : list.last_name || "",
        pob : list.pob || "",
        datebirth : formattedDate || "",
        email : list.email || "",
        nick_name : list.nick_name || "",
        genders : list.genders || "",
        weight : list.weight || "",
        height : list.height || "",
        blood_types : list.blood_types || "",
        religions : list.religions || "",
        citizenships_id : list.citizenships_id || "",
        nth_child : list.nth_child || "",
        siblings : list.siblings || "",
        language : list.language || "",
        phone : list.phone || "",
        entrance_year : list.entrance_year || "",
        address : list.address || "",
        province : list.province || "",
        city : list.city || "",
        districts : list.districts || "",
        sub_districts : list.sub_districts || "",
        years_of_education : list.years_of_education || "",
        classrooms : list.classrooms || "",
        classes : list.classes || "",
        father_name : list.father_name || "",
        mother_name : list.mother_name || ""
      };
    });

    // 1️⃣ Buat workbook & worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data Siswa");

    // 2️⃣ Definisikan kolom
    worksheet.columns = [
    { header: "No VA", key: "no_va", width: 15 },
  { header: "Kelas", key: "classrooms", width: 15 },
  { header: "Tingkat Kelas", key: "classes", width: 15 },
  { header: "Nama Lengkap", key: "students_name", width: 25 },
  { header: "Nick Name", key: "nick_name", width: 20 },
  { header: "NIS", key: "nis", width: 15 },
  { header: "NISN", key: "nisn", width: 15 },
  { header: "NIK", key: "nik", width: 20 },
  { header: "NO KK", key: "no_kk", width: 20 },
  { header: "POB", key: "pob", width: 15 },
  { header: "DOB", key: "dob", width: 15 },
  { header: "L/P", key: "gender", width: 10 },
  { header: "Email", key: "email", width: 25 },
  { header: "BB", key: "bb", width: 10 },
  { header: "TB", key: "tb", width: 10 },
  { header: "Golongan darah", key: "blood_type", width: 15 },
  { header: "Kelainan", key: "kelainan", width: 20 },
  { header: "Hobi", key: "hobi", width: 20 },
  { header: "Agama", key: "agama", width: 15 },
  { header: "Kewarganegaraan", key: "kewarganegaraan", width: 20 },
  { header: "Anak ke", key: "anak_ke", width: 10 },
  { header: "Berapa Bersaudara", key: "bersaudara", width: 15 },
  { header: "Bahasa", key: "bahasa", width: 15 },
  { header: "Telp", key: "telp", width: 15 },
  { header: "Tinggal Dengan", key: "tinggal_dengan", width: 20 },
  { header: "Jarak Rumah ke Sekolah", key: "jarak_rumah", width: 25 },
  { header: "Alamat", key: "alamat", width: 30 },
  { header: "RT", key: "rt", width: 10 },
  { header: "RW", key: "rw", width: 10 },
  { header: "Provinsi", key: "provinsi", width: 20 },
  { header: "Kota", key: "kota", width: 20 },
  { header: "Kecamatan", key: "kecamatan", width: 20 },
  { header: "Kelurahan", key: "kelurahan", width: 20 },
  { header: "Nama Ayah", key: "nama_ayah", width: 25 },
  { header: "NIK Ayah", key: "nik_ayah", width: 20 },
  { header: "Tempat Lahir Ayah", key: "pob_ayah", width: 20 },
  { header: "Tanggal Lahir Ayah", key: "dob_ayah", width: 20 },
  { header: "Kewarganegaraan Lahir Ayah", key: "kewarganegaraan_ayah", width: 25 },
  { header: "Agama Ayah", key: "agama_ayah", width: 15 },
  { header: "No. Telpon Ayah", key: "telp_ayah", width: 20 },
  { header: "Pendidikan Ayah", key: "pendidikan_ayah", width: 20 },
  { header: "Pekerjaan Ayah", key: "pekerjaan_ayah", width: 20 },
  { header: "Jabatan Ayah", key: "jabatan_ayah", width: 20 },
  { header: "Gaji Ayah", key: "gaji_ayah", width: 15 },
  { header: "Status Ayah", key: "status_ayah", width: 15 },
  { header: "Alamat Ayah", key: "alamat_ayah", width: 30 },
  { header: "Nama Ibu", key: "nama_ibu", width: 25 },
    ];

    // 3️⃣ Tambahkan data ke sheet
    excelForm.forEach((row) => worksheet.addRow(row));

    // 4️⃣ Tambahkan dropdown (Data Validation)
    const rowCount = excelForm.length + 1; // header ada di row 1
    for (let i = 2; i <= rowCount; i++) {
      // Kolom I -> Jenis Kelamin
      worksheet.getCell(`L${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"Laki-laki,Perempuan"'],
        showErrorMessage: true,
      };

      // Kolom J -> Golongan Darah
      worksheet.getCell(`P${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"A,B,AB,O+,O-,A+,A-,B+,B-,AB+,AB-,Tidak Tahu"'],
        showErrorMessage: true,
      };

       // Kolom  -> Agama
      worksheet.getCell(`S${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"Katholik,Kristen,Islam,Hindu,Buddha,Konghucu,Lainnya"'],
        showErrorMessage: true,
      };

       // Kolom  -> Kewarganegaraan
      worksheet.getCell(`T${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"WNI,WNA"'],
        showErrorMessage: true,
      };

      // Kolom AL-> Kewarganegaraan
      worksheet.getCell(`AL${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"WNI,WNA"'],
        showErrorMessage: true,
      };

       // Kolom  -> Agama
      worksheet.getCell(`AM${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"Katholik,Kristen,Islam,Hindu,Buddha,Konghucu,Lainnya"'],
        showErrorMessage: true,
      };

       // Kolom  -> Pendidikan
      worksheet.getCell(`A0${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"SD,SMP,SMA,D1/D2/D3,D4/S1,S2,S3"'],
        showErrorMessage: true,
      };

       // Kolom  -> Pekerjaan
      worksheet.getCell(`AP${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"Tidak Bekerja,Petani/Peternak/Nelayan,PNS,TNI/POLRI,Karyawan Swasta,Wiraswasta,Wirausaha,Buruh,Pensiunan,Sudah Meninggal,Lainnya"'],
        showErrorMessage: true,
      };
    }

    // 5️⃣ Styling header biar lebih rapi
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = { vertical: "middle", horizontal: "center" };

    // 6️⃣ Export dan simpan
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "DataSiswa.xlsx");
  };

  return (
    <Button style={{ height: 30, width: 400, marginRight: 9 }} onClick={handleExport}>
      Ekspor Excel
    </Button>
  );
}

 onRenderExcel(listTemp) {
  // console.log(listTemp.details)
  const listDetails = listTemp.details
  const handleExport = async () => {
    const excelForm = listDetails.map((list) => {
      const date = list.datebirth ? list.datebirth : "";
      const [year, month, day] = date ? date.split("-") : ["", "", ""];
      const formattedDate = `${day}-${month}-${year}`;
      return {
        nopin : list.nopin || "",
        nis : list.nis || "",
        nisn : list.nisn || "",
        no_va : list.no_va || "",
        students_name : list.fullname || "",
        last_name : list.last_name || "",
        pob : list.pob || "",
        datebirth : formattedDate || "",
        email : list.email || "",
        nick_name : list.nick_name || "",
        genders : list.gender_name || "",
        disabilities : list.disabilities || "",
        hobby : list.hobby || "",
        weight : list.weight || "",
        height : list.height || "",
        blood_types : list.blood_type_name || "",
        religions : list.religion_name || "",
        citizenships_id : list.citizenship_name || "",
        nth_child : list.nth_child || "",
        siblings : list.siblings || "",
        language : list.language || "",
        phone : list.phone || "",
        entrance_year : list.entrance_year || "",
        address : list.address || "",
        province : list.province || "",
        city : list.city || "",
        districts : list.districts || "",
        sub_districts : list.sub_districts || "",
        years_of_education : list.years_of_education || "",
        classrooms : list.classroom_name || "",
        classes : list.class_name || "",
        father_name : list.father_name || "",
        mother_name : list.mother_name || ""
      };
    });

    // 1️⃣ Buat workbook & worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data Siswa");

    // 2️⃣ Definisikan kolom
    worksheet.columns = [
    { header: "No VA", key: "no_va", width: 15 },
  { header: "Kelas", key: "classrooms", width: 15 },
  { header: "Tingkat Kelas", key: "classes", width: 15 },
  { header: "Nama Lengkap", key: "students_name", width: 25 },
  { header: "Nick Name", key: "nick_name", width: 20 },
  { header: "NIS", key: "nis", width: 15 },
  { header: "NISN", key: "nisn", width: 15 },
  { header: "NIK", key: "nik", width: 20 },
  { header: "NO KK", key: "no_kk", width: 20 },
  { header: "POB", key: "pob", width: 15 },
  { header: "DOB", key: "dob", width: 15 },
  { header: "L/P", key: "genders", width: 10 },
  { header: "Email", key: "email", width: 25 },
  { header: "BB", key: "bb", width: 10 },
  { header: "TB", key: "tb", width: 10 },
  { header: "Golongan darah", key: "blood_types", width: 15 },
  { header: "Kelainan", key: "disabilities", width: 20 },
  { header: "Hobi", key: "hobby", width: 20 },
  { header: "Agama", key: "reiligions", width: 15 },
  { header: "Kewarganegaraan", key: "citizenships_id", width: 20 },
  { header: "Anak ke", key: "nth_child", width: 10 },
  { header: "Berapa Bersaudara", key: "siblings", width: 15 },
  { header: "Bahasa", key: "language", width: 15 },
  { header: "Telp", key: "phone", width: 15 },
  { header: "Tinggal Dengan", key: "house_ownership", width: 20 },
  { header: "Jarak Rumah ke Sekolah", key: "house_school_distance", width: 25 },
  { header: "Alamat", key: "address", width: 30 },
  { header: "RT", key: "rt", width: 10 },
  { header: "RW", key: "rw", width: 10 },
  { header: "Provinsi", key: "province", width: 20 },
  { header: "Kota", key: "city", width: 20 },
  { header: "Kecamatan", key: "district", width: 20 },
  { header: "Kelurahan", key: "sub_district", width: 20 },
  { header: "Nama Ayah", key: "father_name", width: 25 },
  { header: "NIK Ayah", key: "father_nik", width: 20 },
  { header: "Tempat Lahir Ayah", key: "father_pob", width: 20 },
  { header: "Tanggal Lahir Ayah", key: "father_dob", width: 20 },
  { header: "Kewarganegaraan Lahir Ayah", key: "father_citizenship", width: 25 },
  { header: "Agama Ayah", key: "father_name", width: 15 },
  { header: "No. Telpon Ayah", key: "father_phone", width: 20 },
  { header: "Pendidikan Ayah", key: "father_education_name", width: 20 },
  { header: "Pekerjaan Ayah", key: "father_occupation_name", width: 20 },
  { header: "Jabatan Ayah", key: "father_position", width: 20 },
  { header: "Gaji Ayah", key: "father_salary", width: 15 },
  { header: "Status Ayah", key: "father_status", width: 15 },
  { header: "Alamat Ayah", key: "father_address", width: 30 },

  { header: "Nama Ibu", key: "mother_name", width: 25 },
  { header: "NIK Ibu", key: "mother_nik", width: 20 },
  { header: "Tempat Lahir Ibu", key: "mother_pob", width: 20 },
  { header: "Tanggal Lahir Ibu", key: "mother_dob", width: 20 },
  { header: "Kewarganegaraan Lahir Ibu", key: "mother_citizenship", width: 25 },
  { header: "Agama Ibu", key: "mother_name", width: 15 },
  { header: "No. Telpon Ibu", key: "mother_phone", width: 20 },
  { header: "Pendidikan Ibu", key: "mother_education_name", width: 20 },
  { header: "Pekerjaan Ibu", key: "mother_occupation_name", width: 20 },
  { header: "Jabatan Ibu", key: "mother_position", width: 20 },
  { header: "Gaji Ibu", key: "mother_salary", width: 15 },
  { header: "Status Ibu", key: "mother_status", width: 15 },
  { header: "Alamat Ibu", key: "mother_address", width: 30 },

  { header: "Nama Wali", key: "guardian_name", width: 25 },
  { header: "NIK Wali", key: "guardian_nik", width: 20 },
  { header: "Tempat Lahir Wali", key: "guardian_pob", width: 20 },
  { header: "Tanggal Lahir Wali", key: "guardian_dob", width: 20 },
  { header: "Kewarganegaraan Lahir Wali", key: "guardian_citizenship", width: 25 },
  { header: "Agama Wali", key: "guardian_name", width: 15 },
  { header: "No. Telpon Wali", key: "guardian_phone", width: 20 },
  { header: "Pendidikan Wali", key: "guardian_education_name", width: 20 },
  { header: "Pekerjaan Wali", key: "guardian_occupation_name", width: 20 },
  { header: "Jabatan Wali", key: "guardian_position", width: 20 },
  { header: "Gaji Wali", key: "guardian_salary", width: 15 },
  { header: "Status Wali", key: "guardian_status", width: 15 },
  { header: "Alamat Wali", key: "guardian_address", width: 30 },
    ];

    // 3️⃣ Tambahkan data ke sheet
    excelForm.forEach((row) => worksheet.addRow(row));

    // 4️⃣ Tambahkan dropdown (Data Validation)
    const rowCount = excelForm.length + 1; // header ada di row 1
    for (let i = 2; i <= rowCount; i++) {
      // Kolom L -> Jenis Kelamin
      worksheet.getCell(`L${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"Laki-laki,Perempuan"'],
        showErrorMessage: true,
      };

      // Kolom P -> Golongan Darah
      worksheet.getCell(`P${i}`).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: ['"A,B,AB,O+,O-,A+,A-,B+,B-,AB+,AB-,Tidak Tahu"'],
        showErrorMessage: true,
      };

    }

    // 5️⃣ Styling header biar lebih rapi
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(1).alignment = { vertical: "middle", horizontal: "center" };

    // 6️⃣ Export dan simpan
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "DataSiswa.xlsx");
  };

  return (
    <Button style={{ height: 30, width: 400, marginRight: 9 }} onClick={handleExport}>
      Ekspor Detail
    </Button>
  );
}
  _renderButtons(data) {
    const { user } = this.props;

    return (
      <td>
        <div className="table__actions">
          {this.onRenderExcel(data)}
          {/* <Button onClick={() => this.onRenderExcel(data)} title="Lihat Detail" /> */}
          {data.is_posting != 1?
          <Button onClick={() => this.onPosting(data)} title="Posting" />
          :''}
        </div>
      </td>
    );
  }
  render() {
    const { param, filters, form } = this.state;
    const { entrance_year = '', classrooms_id = '' } = filters;
    const { listsiswa, listTemp } = form.value;
    return (
      <div className="fund-request">
        <br />
        <div className="isi-bidang__custom-form">
          <div className="isi-bidang__custom-form-column">
            <div className="isi-bidang__custom-form-row__field">
              <Select
                name="entrance_year"
                label="Tahun Ajaran"
                placeholder="Pilihan"
                onChange={this._onChangeFilter}
                data={param.periods}
                // value={entrance_year?entrance_year:years_now}
                value={filters.period}
                disabled
              />
              <div className="isi-bidang__custom-form-row__field" />
               <Select
                  type="text"
                  name="classrooms_id"
                  label="Kelas"
                  placeholder="Pilih Kelas"
                  data={param.classrooms}
                  onChange={this._onChangeFilter}
                  value={classrooms_id}
                />
            </div>
          </div>
        </div>
        <form onSubmit={this.onSubmit}>
          <br />
          <div className="manage-registration__custom-form-row">
            <div className="manage-registration__custom-form-row__field">
              <FileInput
                data-input-type="file"
                noMargin
                type="file"
                name="file"
                label="Upload File Excel"
                onChange={this.onUpload}
                onRemoveFile={this.onRemoveFile}
                // fileName={value.file ? value.file : ""}
                // displayName={
                //   value.file ? value.file : "default"
                // }
              />
            </div>
            <div className="manage-registration__custom-form-row__field" />
          </div>
          <br />
          <div className="beginning-balance__button-wrapper">

            <Button type="submit" title="Simpan" />
            &nbsp;
             <div style={{ marginLeft: '0rem' }} className="student-list__button">
            {this.renderExcel(listsiswa)}
          </div>
          </div>
          <br></br>
          <div>
            <table className='table'>
              <thead>
                <tr>
                  <th>No</th>
                  <th style={{width: "60%"}}>Kelas</th>
                  <th style={{width: "30%"}}>Opsi</th>
                </tr>
              </thead>
              <tbody>
                   {map(listTemp, (list, idx) => (
                      <tr key={`budget_row_${idx}`}>
                        <td style={{ textAlign: 'center' }} key={`table_$${idx}`}>
                          {idx + 1}
                        </td>
                        <td key={`table_${idx}`} style={{ textAlign: 'center' }}>
                          {list.classrooms_name}
                        </td>
                        {this._renderButtons(list)}
                      </tr>
                    ))}
              </tbody>
            </table>
          </div>
        </form>
      </div>
    );
  }
}
ImportSiswaUnit.propTypes = {
  handleDelete: PropTypes.func,
  history: PropTypes.object.isRequired,
  user: PropTypes.object,
  onRemoveFile: PropTypes.func,
  onFormChange: PropTypes.func,
};
ImportSiswaUnit.defaultProps = {
  handleDelete: noop,
  user: null,
  onFormChange: noop,
  onRemoveFile: noop,
};
